import "lite-youtube-embed";
import "lite-youtube-embed/src/lite-yt-embed.css";

import Slider from "../../Models/SliderModels";

export default class TutorialsSlider extends Slider {

  constructor() {
    super(".similar-tutorials, .slider-with-tutorials", {
      slidesOffsetBefore: 16,
      slidesPerView: 1.25,
          spaceBetween: 16,

      breakpoints: {
        576: {
          slidesPerView: 1.5,
        },
        767: {
          slidesPerView: 2.25,
        },
        991: {
          slidesPerView: 2,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    });
  }
}